<style lang="less" scoped>
@import "./index.less";
.price-tip {
  background: #e97987;
  color: #ffffff;
  display: initial;
  padding: 1px 8px;
  font-size: 12px;
}
</style>
<template>
  <div style="width:1100px;margin:0 auto;overflow-x:auto;">

    <!--表格头部开始-->
    <div class="table-head">
      <div class="table-th first">商品名称</div>
      <div class="table-th">单价（元）</div>
      <div class="table-th">数量</div>
      <div class="table-th">金额（元）</div>
      <div class="table-th">操作</div>
    </div>
    <!--表格头部结束-->

    <!--表格内容开始-->
    <div class="table-content">
      <el-table :data="tableData" style="width: 100%;" :show-header="false" empty-text="空空的购物车">
        <el-table-column label="商品名称">
          <template slot-scope="scope">
            <div class="product-name product-image">
              <img class="watermark" v-if="isSellOut(scope.row.activityProductId)" :src="sellOutImagePath">
              <img :src="scope.row.image" alt="">
            </div>
            <div class="product-name product-string">
              {{ scope.row.productName }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="单价（元）" width="190">
          <template slot-scope="scope">
            <div class="flex col flex-center">
              <div class="price">{{ scope.row.salePrice | price }}</div>
              <div v-if="scope.row.hasDiscount" class="price-tip">预计到手价:{{scope.row.realPrice | price}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="数量" width="190">
          <template slot-scope="scope">
            <el-input-number step-strictly @change="handleEdit(scope.row.activityProductId, scope.row.number,)" :min="1" :max="scope.row.stock || 1" :size="'mini'" v-model="scope.row.number">
            </el-input-number>
          </template>
        </el-table-column>

        <el-table-column label="金额（元）" width="180">
          <template slot-scope="scope">
            <span class="red price">{{ (scope.row.number * scope.row.salePrice) | price }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <span @click="handleDelete(scope.row.activityProductId)" class="action-del">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--表格内容结束-->
    <div class="flex flex-right" style="margin-top: 12px">
      <div style="text-align: right">
        <div>订单合计金额：{{totalPrice | price}}</div>
        <div>优惠：-{{(cartInfo.discountAmount || 0) | price}}</div>
      </div>
    </div>
    <!--表格底部开始-->
    <div class="table-footer">
      <!--<router-link :to="{ name: 'order-confirm'}" v-if="tableData.length > 0">-->
      <!--<p class="right">下单</p>-->
      <!--</router-link>-->
      <p class="right" @click="placeOrder">下单</p>
      <p class="center" onclick="window.history.go(-1)">返回上一页</p>
      <p class="left">
        <span class="price fr">{{(cartInfo.orderAmount||0) | price}}</span>
        <span class="name fr">订单实付金额：</span>
      </p>
      <div v-if="cartInfo.discountInfo" class="flex flex-cc" style="float: left;margin-left: 30px;line-height: 65px;color: #e97987">
        <div>{{cartInfo.discountInfo.purchaseText}}</div>
        <div style="margin-left: 10px;cursor:pointer" @click="toPage">{{cartInfo.discountInfo.clickText}} ></div>
      </div>
    </div>
    <!--表格底部结束-->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { isSellOut } from "@/helpers";
const sellOutImagePath = require('../../assets/watermark/sell-out.png');
import lodash from "lodash"

export default {
  name: 'index',
  data() {
    return {
      num: 1,
      carts: [],
      sellOutImagePath,
      productSpecs: {},
    };
  },
  methods: {
    ...mapMutations('cart', {
      setCart: 'setCart',
    }),
    handleEdit(id, num, row) {
      if (num) {
        this.$store.dispatch('cart/update', { id, num: parseInt(num) });
      } else {
        const cart = lodash.cloneDeep(this.cart)
        const index = cart.findIndex(item => item.activityProductId == id)
        cart[index].number = 0
        this.setCart({ cart })
        this.$nextTick(() => {
          this.$store.dispatch('cart/update', { id, num: 1 });
        })
      }
    },
    handleDelete(id) {
      this.$store.dispatch('cart/del', id);
    },
    isSellOut(activityProductId) {
      if (this.productSpecs[activityProductId] == null) {
        return false;
      }
      return isSellOut(this.productSpecs[activityProductId]);
    },
    async placeOrder() {
      if (!this.tableData.length) return
      const products = this.tableData;
      this.$router.push({ name: 'order-confirm' });
      // await this.$store.dispatch('activityLimit/limit', products).then((result)=>{
      //   if(result.result) {
      //     this.$router.push({name:'order-confirm'});
      //   }
      // });
    },
    toPage() {
      const { name, params } = this.cartInfo.discountInfo.jumpInfo
      this.$router.push({ name, query: params });
    },
    _formatSpecs(specs) {
      const items = []
      specs.forEach((item) => {
        items.push({
          activityProductId: item.activityProductId,
          number: item.number,
        })
      })
      this.productSpecs = items;
      return items
    },
    _formatCart(carts) {
      const items = {};
      carts.forEach(item => {
        items[item.id] = item;
      })
      return items
    },
  },
  beforeMount() {
    const items = this._formatSpecs(this.tableData)
    if (items.length) {
      this.$store.dispatch('cart/updateCartItem', {
        items
      }).then(res => {
        this.productSpecs = this._formatCart(res.items)
      })
    }
  },
  mounted() {
  },
  computed: {
    ...mapState('cart', {
      tableData: state => state.cart,
      cartInfo: state => state.cartInfo,
      cart: state => state.cart,
    }),
    ...mapGetters('cart', {
      cartNum: 'cartNum',
      totalPrice: 'totalPrice',
    }),
  },
};
</script>


